import { PublicHeader } from "@/components/public-header";
import { useSEO } from "@/hooks/use-seo";
import { seoFor } from "@/data/marketing-routes";
import { PublicFooter } from "@/components/public-footer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { VENDOR_FAQ_ITEMS } from "@/data/vendor-faq-items";
import { ShareFaqButton } from "@/components/share-faq-button";

export default function PublicFaqVendorPage() {
  useSEO(seoFor("/faq/vendors"));
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="page-faq-vendor">
      <PublicHeader />
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex items-start justify-between gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Vendor FAQ</h1>
              <p className="text-gray-500">
                Everything you need to know about working with PadPulse as a vendor.
              </p>
            </div>
            <ShareFaqButton path="/faq/vendors" testId="button-share-faq-vendor" className="shrink-0" />
          </div>
          <Accordion type="single" collapsible className="w-full space-y-2">
            {VENDOR_FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-gray-200 rounded-lg overflow-hidden px-4"
                data-testid={`faq-vendor-item-${i}`}
              >
                <AccordionTrigger className="text-sm font-medium text-left py-4 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-gray-600 pb-4 leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
